import TasksService from '../service/tasks'

export default {
  install: function (Vue) {
    Vue.prototype.$tasksService = new TasksService()
  }
}



// WEBPACK FOOTER //
// ./src/plugin/tasks.js